<template lang="html">
  <div id="catalog-form-page">

    <section class="container oversized-container main-section">
      <div class="row pt-4">
        <div class="col pl-sm-0 col-link">
          <router-link class="link-back" to="/inicio"><i class="fal fa-chevron-left icon"></i> <span>Regresar</span></router-link>
        </div>

        <div class="col-lg col-titles col-mid">
          <h1>ISR e IVA por arrendamiento pagos provisionales</h1>
          <hr />
        </div>

        <div class="col col-empty"></div>
      </div>

      <div class="row justify-content-center">
        <!-- Paso 1, Form -->
        <div class="col-12 col-mid col-form" v-if="step == 1">
          <h5 class="mb-4 title">DATOS GENERALES</h5>

          <b-form @submit="onSubmit">
          	<b-form-group class="custom-form-group-s2"
              label="Año del cálculo: "
              label-for="i-anio">
              	<div class="row">
                	<div class="col-12 col-sm">
                  		<b-form-select v-model="form.anio" required oninvalid="this.setCustomValidity('Selecciona una opción')" oninput="setCustomValidity('')">
		                    <b-form-select-option :value="null" disabled selected>Año</b-form-select-option>
		                    <b-form-select-option :value="year.value" v-for="(year, yindx) in years" :key="yindx">{{year.value}}</b-form-select-option>

		                </b-form-select>
                	</div>
             	</div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="El pago provisional es mensual o trimestral: "
              label-for="i-tipo_pago">
                <div class="row">
                  <div class="col-12 col-sm">
                      <b-form-select v-model="form.tipo_pago" required oninvalid="this.setCustomValidity('Selecciona una opción')" oninput="setCustomValidity('')">
                        <b-form-select-option :value="null" disabled selected>Selecciona una opción</b-form-select-option>
                        <b-form-select-option value="mensual">Mensual</b-form-select-option>
                        <b-form-select-option value="trimestral">Trimestral</b-form-select-option>

                    </b-form-select>
                  </div>
              </div>
            </b-form-group>

            <p style="text-align:center;" v-if="form.tipo_pago == 'mensual'">Ingresos mensuales al que corresponde el pago por</p>
            <p style="text-align:center;" v-else-if="form.tipo_pago == 'trimestral'">Ingresos trimestrales al que corresponde el pago por</p>
            <hr>
            <b-form-group class="custom-form-group-s2"
              label="Locales comerciales:"
              label-for="i-vent" id="input-locales_comerciales">

              <currency-input id="i-vent" class="form-control"
                v-model="form.locales_comerciales" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.locales_comerciales != null" style="color: red;"><small>{{validation.locales_comerciales}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Casa habitación amueblada:"
              label-for="i-vent" id="input-casa_habitacion_amueblada">

              <currency-input id="i-vent" class="form-control"
                v-model="form.casa_habitacion_amueblada" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.casa_habitacion_amueblada != null" style="color: red;"><small>{{validation.casa_habitacion_amueblada}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Casa habitación sin amueblar:"
              label-for="i-vent" id="input-casa_habitacion_sinamueblar">

              <currency-input id="i-vent" class="form-control"
                v-model="form.casa_habitacion_sinamueblar" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.casa_habitacion_sinamueblar != null" style="color: red;"><small>{{validation.casa_habitacion_sinamueblar}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Inmuebles destinados a fines agrícolas o ganaderos:"
              label-for="i-vent" id="input-inmuebles_agrícolas_ganaderos">

              <currency-input id="i-vent" class="form-control"
                v-model="form.inmuebles_agrícolas_ganaderos" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.inmuebles_agrícolas_ganaderos != null" style="color: red;"><small>{{validation.inmuebles_agrícolas_ganaderos}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Uso o goce temporal de maquinaria y equipo art. 2a, fracc. III de LIVA:"
              label-for="i-vent" id="input-uso_gose_maquinaria">

              <currency-input id="i-vent" class="form-control"
                v-model="form.uso_gose_maquinaria" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.uso_gose_maquinaria != null" style="color: red;"><small>{{validation.uso_gose_maquinaria}}</small></div>
            </b-form-group>

            <p style="text-align:center;" v-if="form.tipo_pago == 'mensual'">Deducciones mensuales al que corresponde el pago por</p>
            <p style="text-align:center;" v-else-if="form.tipo_pago == 'trimestral'">Deducciones trimestrales al que corresponde el pago por</p>
            <hr>
            <b-form-group class="custom-form-group-s2"
              label="Impuesto predial:"
              label-for="i-vent" id="input-impuesto_predial">

              <currency-input id="i-vent" class="form-control"
                v-model="form.impuesto_predial" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.impuesto_predial != null" style="color: red;"><small>{{validation.impuesto_predial}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="¿Opta por la deducción ciega?: "
              label-for="i-tipo_pago">
                <div class="row">
                  <div class="col-12 col-sm">
                      <b-form-select v-model="form.deduccion_ciega" required oninvalid="this.setCustomValidity('Selecciona una opción')" oninput="setCustomValidity('')">
                        <b-form-select-option :value="null" disabled selected>Selecciona una opción</b-form-select-option>
                        <b-form-select-option value="si">Sí</b-form-select-option>
                        <b-form-select-option value="no">No</b-form-select-option>

                    </b-form-select>
                  </div>
              </div>
            </b-form-group>

             <b-form-group class="custom-form-group-s2"
              label="Gastos de mantenimiento:"
              label-for="i-vent" id="input-gastos_mantenimiento"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.gastos_mantenimiento" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.gastos_mantenimiento != null" style="color: red;"><small>{{validation.gastos_mantenimiento}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Primas de seguro sobre los bienes arrendados:"
              label-for="i-vent" id="input-primas_seguro"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.primas_seguro" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.primas_seguro != null" style="color: red;"><small>{{validation.primas_seguro}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Inversiones en construcciones, incluyendo adiciones y mejoras (depreciación de inversiones actualizada):"
              label-for="i-vent" id="input-inversiones"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.inversiones" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.inversiones != null" style="color: red;"><small>{{validation.inversiones}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Intereses reales pagados:"
              label-for="i-vent" id="input-interes_reales_pagados"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.interes_reales_pagados" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.interes_reales_pagados != null" style="color: red;"><small>{{validation.interes_reales_pagados}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Sueldos y salarios:"
              label-for="i-vent" id="input-sueldos_salarios"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.sueldos_salarios" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.sueldos_salarios != null" style="color: red;"><small>{{validation.sueldos_salarios}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Comisiones y honorarios pagados:"
              label-for="i-vent" id="input-comisiones_honorarios"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.comisiones_honorarios" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.comisiones_honorarios != null" style="color: red;"><small>{{validation.comisiones_honorarios}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Impuesto sobre la nómina:"
              label-for="i-vent" id="input-impuesto_nomina"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.impuesto_nomina" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.impuesto_nomina != null" style="color: red;"><small>{{validation.impuesto_nomina}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="Cuotas patronales (IMSS, AFORE e INFONAVIT):"
              label-for="i-vent" id="input-cuotas_patronales"
              v-if="form.deduccion_ciega == 'no'">

              <currency-input id="i-vent" class="form-control"
                v-model="form.cuotas_patronales" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.cuotas_patronales != null" style="color: red;"><small>{{validation.cuotas_patronales}}</small></div>
            </b-form-group>

            <p style="text-align:center;">IVA acreditable y retenciones de IVA e ISR</p>
            <hr>
            <b-form-group class="custom-form-group-s2"
              label="IVA acreditable del período:"
              label-for="i-vent" id="input-iva_acreditable_periodo">

              <currency-input id="i-vent" class="form-control"
                v-model="form.iva_acreditable_periodo" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.iva_acreditable_periodo != null" style="color: red;"><small>{{validation.iva_acreditable_periodo}}</small></div>
            </b-form-group>
            <b-form-group class="custom-form-group-s2"
              label="IVA acreditable de períodos anteriores pendientes de aplicar:"
              label-for="i-vent" id="input-iva_acreditable_periodos_pendientes">

              <currency-input id="i-vent" class="form-control"
                v-model="form.iva_acreditable_periodos_pendientes" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.iva_acreditable_periodos_pendientes != null" style="color: red;"><small>{{validation.iva_acreditable_pendiente}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="IVA retenido:"
              label-for="i-vent" id="input-iva_retenido">

              <currency-input id="i-vent" class="form-control"
                v-model="form.iva_retenido" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.iva_retenido != null" style="color: red;"><small>{{validation.iva_retenido}}</small></div>
            </b-form-group>

            <b-form-group class="custom-form-group-s2"
              label="ISR retenido:"
              label-for="i-vent" id="input-isr_retenido">

              <currency-input id="i-vent" class="form-control"
                v-model="form.isr_retenido" placeholder="$0.00" required oninvalid="this.setCustomValidity('Completa este campo')" oninput="setCustomValidity('')"/>
              <div v-if="validation.isr_retenido != null" style="color: red;"><small>{{validation.isr_retenido}}</small></div>
            </b-form-group>

            <p class="mt-3 mt-lg-5 pt-sm-4 text-center">
              <b-button type="submit" class="_btn-st1 btn-orange" id="btn_calc">Calcular</b-button>
            </p>
          </b-form>
        </div>
        <!-- Paso 1, FIN -->

        <!-- Paso 2, Mostrar datos -->
        <div class="col-12 col-mid col-results" v-if="step == 2">
          <!-- <h5 class="title">DATOS GENERALES</h5> -->
          <div class="row">
            <!-- <div class="col-12 col-line">
              <hr />
            </div> -->

            <div class="col-12 col-subbox">
              <div class="row align-items-center">
                <div class="col col-text">
                  <h2 class="trans-250 title with-link" @click="scrolltoTable">CONSULTAR FUNDAMENTOS LEGALES <i class="fas fa-info-circle icon"></i></h2>
                </div>

                <!-- <div class="col col-share">
                  <a class="trans-150 btn-share" v-b-modal.modal-compartir>Compartir <i class="fas fa-share-alt"></i></a>
                </div> -->
              </div>
            </div>
            <p style="text-align: center;"><b>IVA e ISR por pagar del período</b></p>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Base gravable para el pago provisional:
                </div>
                <div class="col col-med">
                  {{detailInfo.base_gravable}}
                </div>
              </div>
            </div>

            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  ISR de conformidad con el art. 96 de la LISR:
                </div>
                <div class="col col-med">
                  {{detailInfo.isr_conformidad}}
                </div>
              </div>
            </div>

            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  ISR retenido:
                </div>
                <div class="col col-med">
                  {{detailInfo.isr_retenido}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  ISR a pagar:
                </div>
                <div class="col col-med col-strong">
                  {{detailInfo.isr_apagar}}
                </div>
              </div>
            </div>


            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA trasladado:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_trasladado}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA acreditable del período:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_acreditable_periodo}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA retenido: (y en su caso acreditado en el pago):
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_retenido}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA a cargo (saldo a favor) del período:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_acargo}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA acreditable de períodos anteriores pendiente de aplicar:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_acreditable_periodos_pendientes}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA a pagar:
                </div>
                <div class="col col-med col-strong">
                  {{detailInfo.iva_apagar}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Total de IVA e ISR por pagar:
                </div>
                <div class="col col-med col-strong">
                  {{detailInfo.total_isr_iva_pagar}}
                </div>
              </div>
            </div>
            <p style="text-align: center;"><b>Resumen de los actos o actividades para efectos del IVA</b></p>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Gravados a la tasa general (16%):
                </div>
                <div class="col col-med">
                  {{detailInfo.gravados_tasa_general}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Gravados a la tasa del 0%:
                </div>
                <div class="col col-med">
                  {{detailInfo.gravados_tasa_cero}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Exentos para el IVA:
                </div>
                <div class="col col-med">
                  {{detailInfo.exentos_iva}}
                </div>
              </div>
            </div>

            <p style="text-align:center;"><b>Resumen de las retenciones de ISR, IVA y el saldo del remanente de IVA por aplicar</b></p>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA retenido y acreditado en el período del cálculo:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_retenido_acreditado}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  IVA a cargo del perídodo antes del acreditamiento del IVA de períodos anteriores declarados:
                </div>
                <div class="col col-med">
                  {{detailInfo.iva_acargo_antes}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Remanente de IVA acreditable de períodos anteriores pendiente de aplicar después de este cálculo:
                </div>
                <div class="col col-med">
                  {{detailInfo.remanente_iva}}
                </div>
              </div>
            </div>
            <div class="col-12 col-info">
              <div class="row row-body">
                <div class="col col-detail">
                  Saldo a favor del IVA del período del cálculo:
                </div>
                <div class="col col-med">
                  {{detailInfo.saldo_favor}}
                </div>
              </div>
            </div>

            <div class="col-12 col-options">
              <p class="mb-3">
                <a type="button" class="btn _btn-st1" :href="detailInfo.links.excel" target="_blank">Exportar a Excel</a>
                <a type="button" class="btn _btn-st1" :href="detailInfo.links.pdf" target="_blank">Exportar a PDF</a>
              </p>
              <p>
                <b-button type="submit" class="_btn-st1 btn-orange" @click="otherCalc">Hacer otro cálculo</b-button>
              </p>
            </div>

          </div>
        </div>
        <!-- Paso 2, FIN -->

        <!-- Fundamentos legales -->
        <flegales-component id="table-flegales"></flegales-component>
        <!--  -->

      </div>
    </section>

    <!-- ******** Modals ******** -->
    <!-- Modal "Compartir a Correo" -->
    
    <!--  -->
    <b-modal id="modal-loading" ref="modal-loading" hide-footer hide-header centered no-close-on-backdrop no-close-on-esc modal-class="modal-st-1">
        <div style="text-align: center;">
          <img src="public/images/shared/loading2.gif">
          <br><br><h3>Realizando cálculo</h3>
        </div>
    </b-modal>

  </div>
</template>

<script>
import FlegalesComponent from './components/fleg-comp-isr-iva-por-arrendamiento-pagos-provisionales.vue';
export default {
  data(){
    return{
      step: 1,
      // showModalFLegales: false,
      showFLegalesComp: false,

      form:{
        anio:null,
        tipo_pago:null,
        locales_comerciales:null,
        casa_habitacion_amueblada:null,
        casa_habitacion_sinamueblar:null,
        inmuebles_agrícolas_ganaderos:null,
        uso_gose_maquinaria:null,
        impuesto_predial:null,
        deduccion_ciega:null,

        gastos_mantenimiento:null,
        primas_seguro:null,
        inversiones:null,
        interes_reales_pagados:null,
        sueldos_salarios:null,
        comisiones_honorarios:null,
        impuesto_nomina:null,
        cuotas_patronales:null,

        iva_acreditable_periodo:null,
        iva_acreditable_periodos_pendientes:null,
        iva_retenido:null,
        isr_retenido:null,


      },

      formComp: {
        email: null
      },

      years:[],
      months:[
        {value:1,name:'Enero'},
        {value:2,name:'Febrero'},
        {value:3,name:'Marzo'},
        {value:4,name:'Abril'},
        {value:5,name:'Mayo'},
        {value:6,name:'Junio'},
        {value:7,name:'Julio'},
        {value:8,name:'Agosto'},
        {value:9,name:'Septiembre'},
        {value:10,name:'Octubre'},
        {value:11,name:'Noviembre'},
        {value:12,name:'Diciembre'},
      ],
      daysone:[],
      daystwo:[],

      detailInfo:[],
      validation:{
  			anio:null,
        tipo_pago:null,
        locales_comerciales:null,
        casa_habitacion_amueblada:null,
        casa_habitacion_sinamueblar:null,
        inmuebles_agrícolas_ganaderos:null,
        uso_gose_maquinaria:null,
        impuesto_predial:null,
        deduccion_ciega:null,

        gastos_mantenimiento:null,
        primas_seguro:null,
        inversiones:null,
        interes_reales_pagados:null,
        sueldos_salarios:null,
        comisiones_honorarios:null,
        impuesto_nomina:null,
        cuotas_patronales:null,

        iva_acreditable_periodo:null,
        iva_acreditable_periodos_pendientes:null,
        iva_retenido:null,
        isr_retenido:null,
  		}
    }
  },
  watch:{
    'form.mes1':function(val)
    {
      var fecha = new Date();
      if (this.form.anio1 == null) {
          var anio = fecha.getFullYear();
      }
      else{
          var anio  = this.form.anio1;
      }
      var d = new Date(anio, val, 0);
      var days =[];
      for (var i = 1; i <= d.getDate(); i++) {
        var aux = {
          'value':i
        };
        days.push(aux);
      }
      this.daysone = days;
    },
    'form.anio1':function(val)
    {
      var fecha = new Date();
      if (val == null) {
          var anio = fecha.getFullYear();
      }
      else{
          var anio  = val;
      }
      var d = new Date(anio, this.form.mes1, 0);
      var days =[];
      for (var i = 1; i <= d.getDate(); i++) {
        var aux = {
          'value':i
        };
        days.push(aux);
      }
      this.daysone = days;
    },
    'form.mes2':function(val)
    {
      var fecha = new Date();
      if (this.form.anio2 == null) {
          var anio = fecha.getFullYear();
      }
      else{
          var anio = this.form.anio2;
      }
      var d = new Date(anio, val, 0);
      var days =[];
      for (var i = 1; i <= d.getDate(); i++) {
        var aux = {
          'value':i
        };
        days.push(aux);
      }
      this.daystwo = days;
    },
    'form.anio2':function(val)
    {
      var fecha = new Date();
      if (val == null) {
          var anio = fecha.getFullYear();
      }
      else{
          var anio  = val;
      }
      var d = new Date(anio, this.form.mes2, 0);
      var days =[];
      for (var i = 1; i <= d.getDate(); i++) {
        var aux = {
          'value':i
        };
        days.push(aux);
      }
      this.daystwo = days;
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    onSubmit(event) { // Enviar formulario del paso 1
      event.preventDefault();
      
		  /*this.validation.salario_diario = null;
		


      
      if (this.form.salario_diario == 0 || this.form.salario_diario == null) {
          this.validation.salario_diario = '"Salario diari" debe de ser mayor a 0';
          var scrollt = document.getElementById("input-salario_diario").offsetTop;
          setTimeout( ()=>{
            window.scrollTo({ top: scrollt, left: 0, behavior: 'smooth' });
          }, 200);
          return;
      }
      if (this.form.ultimo_sueldo == 0 || this.form.ultimo_sueldo == null) {
          this.validation.ultimo_sueldo = '"Importe del último sueldo mensual ordinario" debe de ser mayor a 0';
          var scrollt = document.getElementById("input-ultimo_sueldo").offsetTop;
          setTimeout( ()=>{
            window.scrollTo({ top: scrollt, left: 0, behavior: 'smooth' });
          }, 200);
          return;
      }*/
    
      this.$refs['modal-loading'].show();
      //$('#btn_calc').hide();
      
      axios.post(tools.url("/calculateThirteen"),this.form).then((response)=>{
          this.detailInfo = response.data;
          this.$refs['modal-loading'].hide();
          this.step = 2;
      }).catch((error)=>{
          $('#btn_calc').show();
          this.$refs['modal-loading'].hide();
          alert('Ocurrio un error al calcular la informacion');
      });
    },
    otherCalc(){
      location.reload();
    },

    scrolltoTable(){
      var tablePosY = document.getElementById("table-flegales").offsetTop;
      this.showFLegalesComp = true;

      setTimeout( ()=>{
        window.scrollTo({ top: tablePosY, left: 0, behavior: 'smooth' });
      }, 200);
    },

    onSubmitComp(event) { // Enviar formulario compartir del Modal "Compartir a Correo"
      event.preventDefault();
      this.$refs['modal-compartir'].hide();

      console.log("Compartir cálculo");
    },

    onSubmitCalc(event) { // Guardar cálculo y regresar a paso 1
      event.preventDefault();

      var keys = Object.keys(this.form);
      var resetForm = {};
      keys.forEach(key => resetForm[key] = null);
      this.form = resetForm;

      this.step = 1;
      this.$refs['modal-gcalculo'].hide();

      console.log("Hacer otro cálculo");
    },
  },

  mounted(){
    var fecha = new Date();
    var anio = fecha.getFullYear();
    var years = [];
    for (var i = 2016; i <= anio; i++) {
        var aux = {
          'value':i
        };
        years.push(aux);
    }

    years.reverse();
    this.years = years;
  },

  components: {
    FlegalesComponent
  },
}
</script>
